import { NgModule } from '@angular/core';
import { IconsListComponent } from './icons-list.component';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { IconItemComponent } from './icon-item/icon-item.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [IconsListComponent, IconItemComponent],
  exports: [IconsListComponent, IconItemComponent],
  entryComponents: [IconsListComponent, IconItemComponent],
  imports: [CommonModule, AngularSvgIconModule, OverlayModule, PipesModule]
})
export class IconsListModule {}

export { IconsListComponent, IconItemComponent };
